import UiTooltipInfo from "@/components/Ui/Tooltip/Info";
import type { SupStoredTxSettings } from "@/types";
import { SupInfoCircle } from "@repo/core-ui";
import React, { type Dispatch, type SetStateAction, useCallback } from "react";

import { SupRadio, SupText, SupTooltip } from "@repo/core-ui";

interface Web3TxSettingsGroupRetainVaultSharesProps {
  settings: SupStoredTxSettings;
  setSettings: Dispatch<SetStateAction<SupStoredTxSettings>>;
}

export default function Web3TxSettingsGroupRetainVaultShares({ settings, setSettings }: Web3TxSettingsGroupRetainVaultSharesProps) {
  const onSetRetain4626 = useCallback(
    (value: boolean) => {
      if (settings.retain4626 !== value) {
        setSettings({
          ...settings,
          retain4626: value,
        });
      }
    },
    [setSettings, settings]
  );

  return (
    <div className="space-y-2">
      <div className="flex h-5 items-center space-x-2">
        <SupText variant="subtitle1" className="mb-0.5">
          Retain Vault Shares
        </SupText>
        <SupTooltip content={<UiTooltipInfo content="When enabled, you will receive vault shares on withdrawal" title="Retain Vault Shares" />} color="default">
          <div>
            <SupInfoCircle />
          </div>
        </SupTooltip>
      </div>
      <div className="leading-12 flex w-full flex-col justify-center space-y-2">
        <SupRadio label="Enabled" name="retain4626" onChange={() => onSetRetain4626(true)} checked={settings.retain4626} />
        <SupRadio label="Disabled" name="retain4626" onChange={() => onSetRetain4626(false)} checked={!settings.retain4626} />
      </div>
    </div>
  );
}
